/**
 * Static UI chrome for the campaign browsers: the category filter display labels.
 *
 * These are presentation-only labels keyed by the data's value, so they live in the
 * component layer (English copy is the i18n key) rather than the mock data. Both
 * browsers import this map and translate it at their render site.
 *
 * There is no tab-label map: both browsers build their tab labels from a total
 * `Record<TabId, string>` of `t()` calls, so a fallback map could never be reached.
 */
export const CAMPAIGN_FILTER_LABELS: Record<string, string> = {
  seasonal: 'Seasonal',
  sports: 'Sports',
  promo: 'Promo',
  acquisition: 'Acquisition',
  // Operations promotions add a Retention category (the acquisition browser
  // doesn't surface this chip, so it's harmless there).
  retention: 'Retention',
};
